import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import FetchLocalStorageDataByPath from './utils/helper/FetchLocalstorageDataByPath';
import { GlobalLoader } from './newcomponents/GlobalLoader/GlobalLoader';

const PrivateRoute = ({ element, adminOnly, ...rest }) => {
  const [isFeatureActive, setIsFeatureActive] = useState({});
  const { path } = rest;
  const newPath = path.slice(1);
  const location = useLocation();
  const auth = useAuth();

  const isAuthenticated = () => {
    let token = sessionStorage.getItem('authorizationToken');
    return token && token !== null  ;
  };

  const isAdmin = () => {
    try {
      const raw = sessionStorage.getItem('groups');
      if (!raw || raw === 'undefined') return false;
      const groups = JSON.parse(raw);
      return Array.isArray(groups) && groups.includes('Admin');
    } catch {
      return false;
    }
  };
  useEffect(() => {
    getLocalStorageDataFunc();
  }, [path]);

  const getLocalStorageDataFunc = () => {
    try {
      const features = FetchLocalStorageDataByPath('system_config', 'features') ?? [];

      const foundFeature = features.find((item) => item.path_name === newPath);

      if (foundFeature) {
        setIsFeatureActive((prev) => ({
          ...prev,
          [newPath]: foundFeature.value,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  if (auth?.isLoading || auth?.activeNavigator) {
    return <GlobalLoader />;
  }

  if (auth?.isAuthenticated && !sessionStorage.getItem('authorizationToken')) {
    return <GlobalLoader />;
  }

  const isAuth = isAuthenticated();

  if (!isAuth) {
    if (location?.pathname?.includes('buow') && location?.search?.includes('email')) {
      sessionStorage.setItem('redirectTo', location.pathname);
    }

    return <Navigate to="/access-error" />;
  }

  if (adminOnly && !isAdmin()) {
    return <Navigate to="/inbasketpage" />;
  }

  if (isFeatureActive.hasOwnProperty(newPath)) {
    return isFeatureActive[newPath] ? element : <Navigate to="/inbasketpage" />;
  }

  return element;
};

export default PrivateRoute;